import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import axios from "axios";
import '../../App.css';
import ChartPie from '../js/ChartPie';
import ChartGauge from '../js/ChartGauge';
import ChartDonut from '../js/ChartDonut';
import ChartLine from '../js/ChartLine';
import { 
    BarChart,
    Line,
    LineChart,  
    Pie, 
    PieChart, 
    Cell, 
    Bar, 
    XAxis, 
    YAxis, 
    CartesianGrid, 
    Tooltip, 
    Legend, 
    ResponsiveContainer
} from 'recharts';

export default function OviewMain(){
    useEffect(() => {
        document.title = "Overview"; // Set the tab name
    }, []);

    const [dataCounts, setDataCounts] = useState({
        requestedTotal: 0,
        requestedNew: 0,
        requestedInProgress: 0,
        requestedCompleted: 0
    });

    const [statusCounts, setStatusCounts] = useState({
        requestPlaced: 0,
        inReview: 0,
        accepted: 0,
        rejected: 0,
        paymentSent: 0,
        processing: 0,
        forReleasing: 0,
        completed: 0,
        outForDeliveryReadyPickup: 0,
        receivedClaimed: 0,
        inTransit: 0,
        outForDelivery: 0,
        readyToPickUp: 0,
        received: 0,
        claimed: 0,
        delivered: 0
    });

    const [documentData, setDocumentData] = useState([]);
    const [topDocuments, setTopDocuments] = useState([]);

    // Colors for Pie Chart
    const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#ff7300", "#ff4d4d", "#0088FE", "#00C49F"];

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
          const data = payload[0];
          const docName = data.payload.doc_name;
          const colorIndex = topDocuments.findIndex(doc => doc.doc_name === docName);
          const fillColor = COLORS[colorIndex % COLORS.length];
      
          return (
            <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '10px', borderRadius: '5px' }}>
              <i style={{ color: fillColor }}>{`${docName}: ${data.value}`}</i>
            </div>
          );
        }

        return null;
    };

    // const CustomTooltip = ({ active, payload }) => {
    //     if (active && payload && payload.length) {
    //       const data = payload[0].payload;
      
    //       // Ensure the index is derived from the actual data
    //       const index = payload[0].payload.index || payload[0].dataIndex || 0;
    //       const color = COLORS[index % COLORS.length];
      
    //       return (
    //         <div style={{ backgroundColor: '#fff', border: `2px solid ${color}`, padding: '10px', borderRadius: '5px' }}>
    //           {Object.keys(data).map((key, i) => (
    //             <div key={key} style={{ marginBottom: '5px' }}>
    //               {i === 0 ? (
    //                 <span style={{ color }}>{data[key]}</span> // First key value without label
    //               ) : (
    //                 <span>
    //                   <em>{key.replace(/_/g, ' ')}:</em> {data[key]}
    //                 </span>
    //               )}
    //             </div>
    //           ))}
    //         </div>
    //       );
    //     }
    //     return null;
    //   }; 

    useEffect(() => {
        const fetchTopRequestedDocuments = async () => {
            try {
                const response = await axios.get("https://docuquest-swu.swucite.tech/api_drts/getTopRequestedDocuments.php");
                //console.log("Top Requested Documents:", response.data);
                setTopDocuments(response.data);
            } catch (error) {
                //console.error("Error fetching top requested documents:", error);
            }
        };

        const fetchBlocks = async () => {

            try {
                const responseTotal = await axios.get("https://docuquest-swu.swucite.tech/api_drts/getTotalDocuments.php");
                const blocksData = responseTotal.data;
                
                //console.warn("Blocks:", blocksData);
                
                setDataCounts(prevState => ({
                    ...prevState,
                    requestedTotal: blocksData.total_requests,
                    requestedNew: blocksData.total_unread,
                    requestedInProgress: blocksData.total_review,
                    requestedCompleted: blocksData.total_unclaimed,
                }));
            } catch (error) {
                //console.error("Error fetching total document count:", error);
            }
        };

        // this should not affect the data blocks
        const fetchRequestsByStatus = async () => {
            try {
                const response = await axios.get("https://docuquest-swu.swucite.tech/api_drts/getRequestStatusCounts.php");

                setStatusCounts({
                    requestPlaced: response.data.request_placed || 0,
                    inReview: response.data.in_review || 0,
                    accepted: response.data.accepted || 0,
                    rejected: response.data.rejected || 0,
                    paymentSent: response.data.payment_sent || 0,
                    processing: response.data.processing || 0,
                    forReleasing: response.data.for_releasing || 0,
                    completed: response.data.completed || 0,
                    outForDeliveryReadyPickup: response.data.out_for_delivery_ready_pickup || 0,
                    receivedClaimed: response.data.received_claimed || 0,
                    inTransit: response.data.in_transit || 0,
                    outForDelivery: response.data.out_for_delivery || 0,
                    readyToPickUp: response.data.ready_to_pick_up || 0,
                    received: response.data.received || 0,
                    claimed: response.data.claimed || 0,
                    delivered: response.data.delivered || 0
                });
            } catch (error) {
                //console.error("Error fetching request status counts:", error);
            }
        };

        const fetchDocumentsByYear = async () => {
            try {
                const response = await axios.get("https://docuquest-swu.swucite.tech/api_drts/getDocumentsByYear.php");
                //console.log("docs by year", response.data);
                setDocumentData(response.data);
            } catch (error) {
                //console.error("Error fetching document data:", error);
            }
        };

        fetchTopRequestedDocuments();
        fetchBlocks();
        fetchRequestsByStatus();
        fetchDocumentsByYear();
    }, []);

    // debugging
    // useEffect(() => {
    //     console.warn("new topDocuments values:", topDocuments);
    //     console.warn("new dataCounts data", dataCounts);
    // }, [topDocuments, dataCounts]);

    const [updateTrigger, setUpdateTrigger] = useState(false);

    const abbreviateNumber = (number) => {
        if (number >= 1_000_000) {
            return (number / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'; // Abbreviate to 'M' for millions
        } else if (number >= 1_000) {
            return (number / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'; // Abbreviate to 'K' for thousands
        }
        return number.toString(); // Return the number as a string if under 1,000
    };

    const refreshTopData = () => {
        setUpdateTrigger(!updateTrigger);
    };

    const navigate = useNavigate();
    
    return (
        <div>
            <section className='dash_overview'>
                <article className='stat_box standalone'>
                    <h6 className='title'>Documents&nbsp;Requested&nbsp;Total</h6>
                    <p className='title body'>{dataCounts.requestedTotal}</p>
                </article>

                <article className='stat_box standalone'>
                    <h6 className='title'>Unread&nbsp;Requests</h6>
                    <p className='title body'>{dataCounts.requestedNew}</p>
                </article>

                <article className='stat_box standalone'>
                    <h6 className='title'>In&nbsp;Review&nbsp;Requests</h6>
                    <p className='title body'>{dataCounts.requestedInProgress}</p>
                </article>

                <article className='stat_box standalone'>
                    <h6 className='title'>Unclaimed&nbsp;Requests</h6>
                    <p className='title body'>{dataCounts.requestedCompleted}</p>
                </article>
            </section>

            <section className='dash_overview content'>

                <article className='stats'>
                    <h5 className='title'>Top 5 Requested Documents</h5>
                    <article className='stat_box'>
                        {/* <ChartDonut/> */}
                        {topDocuments.length > 0 ? (
                            <ResponsiveContainer width="100%" height={300}>
                                <BarChart data={topDocuments} layout="vertical" margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis 
                                      type="number"
                                      domain={[0, 80]}
                                      ticks={[0, 20, 40, 60, 80, 100]}
                                      tickFormatter={(tick) => `${tick}`}
                                      label={{ 
                                        value: 'Number of Requests', 
                                        position: 'insideBottom', 
                                        offset: -10, 
                                        style: { fill: '#555', fontSize: 14 } 
                                      }}
                                      tick={{ dy: 2 }}
                                    />
                                    <YAxis dataKey="doc_name" type="category" width={120} />
                                    
                                    <Tooltip content={<CustomTooltip topDocuments={topDocuments} />} />
                                    
                                    <Legend
                                      wrapperStyle={{ 
                                        paddingTop: '20px' // Adjust this to move legend down
                                      }}
                                      payload={topDocuments.map((doc, index) => ({
                                        value: `${doc.request_count}`,
                                        type: 'square',
                                        color: COLORS[index % COLORS.length],
                                     }))}
                                    />


                                    <Bar dataKey="request_count" barSize={30}>
                                        {topDocuments.map((_, index) => (
                                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                        ))}
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                        ) : (
                            <p style={{ textAlign: "center", padding: "20px", fontSize: "16px" }}>
                                No data available or loading...
                            </p>
                        )}
                    </article>
                </article>

                <article className='stats'>
                    <h5 className='title'>Requests Processed Per Year</h5>
                    <article className='stat_box'>
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={documentData} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="year" />
                                <YAxis />
                                <Tooltip />
                                <Legend
                                    payload={documentData.map((y, index) => ({
                                      value: `${y.year}`,
                                      type: 'square',
                                      color: COLORS[index % COLORS.length],
                                    }))}
                                />
                                {documentData.map((entry, index) => (
                                    <Bar key={entry.year} dataKey="count" fill={COLORS[index % COLORS.length]} />
                                ))}
                            </BarChart>
                        </ResponsiveContainer>
                    </article>
                </article>                
            </section>
        </div>
    )
}